import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../config/firebase';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/dashboard'); // Nous créerons cette route plus tard
    } catch (error) {
      switch (error.code) {
        case 'auth/invalid-email':
          setError('Email invalide');
          break;
        case 'auth/user-not-found':
        case 'auth/wrong-password':
          setError('Email ou mot de passe incorrect');
          break;
        default:
          setError('Une erreur est survenue');
          break;
      }
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-logo">
          <img src="/images/PANDA.png" alt="Logo de l'entreprise" />
        </div>
        <h1>Espace Administrateur</h1>
        <form onSubmit={handleSubmit}>
          {error && <div className="error-message">{error}</div>}
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              required
            />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Mot de passe"
              required
            />
          <button type="submit">Se connecter</button>
        </form>
      </div>
    </div>
  );
};

export default Login; 